import React from "react";

export default function FloatingButton() {
  return (
    <div className="fixed bottom-6 right-6 z-40">
      <a
        href="#top"
        className="pulse-node flex items-center justify-center w-12 h-12 rounded-full border border-[#D4AF6A] text-[#D4AF6A] bg-[#081712]/80 backdrop-blur-sm hover:bg-[#D4AF6A] hover:text-[#081712] transition-colors duration-300"
        aria-label="Back to top"
      >
        <i className="fas fa-arrow-up"></i>
      </a>
    </div>
  );
}
